import * as React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";

const bodyFieldProps = {
  disableUnderline: true,
  style: { fontSize: "0.9rem", lineHeight: 1.8, color: "#424242", padding: 0 },
};

export interface ProviderEmailDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  bodyBefore: string;
  onBodyBeforeChange: (value: string) => void;
  bodyAfter: string;
  onBodyAfterChange: (value: string) => void;
  reason: string;
  onReasonChange: (value: string) => void;
  reasonLabel: string;
  reasonPlaceholder: string;
  reasonHelperText: string;
  reasonError: boolean;
  reasonHighlight: boolean;
  loading: boolean;
  sendDisabled: boolean;
  onSend: () => void;
  done: boolean;
  doneContent?: React.ReactNode;
}

export const ProviderEmailDialog: React.FC<ProviderEmailDialogProps> = ({
  open,
  onClose,
  title,
  subtitle,
  bodyBefore,
  onBodyBeforeChange,
  bodyAfter,
  onBodyAfterChange,
  reason,
  onReasonChange,
  reasonLabel,
  reasonPlaceholder,
  reasonHelperText,
  reasonError,
  reasonHighlight,
  loading,
  sendDisabled,
  onSend,
  done,
  doneContent,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle style={{ backgroundColor: "#e3f2fd", borderBottom: "1px solid #90caf9" }}>
      <Typography variant="h6" style={{ color: "#1565c0", fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="body2" style={{ color: "#1976d2", marginTop: 4 }}>
        {subtitle}
      </Typography>
    </DialogTitle>
    <DialogContent style={{ paddingTop: 20 }}>
      {!done ? (
        <Box style={{
          padding: 20,
          backgroundColor: "#fafafa",
          border: "1px solid #e0e0e0",
          borderRadius: 4,
          fontSize: "0.9rem",
          lineHeight: 1.8,
          color: "#424242",
        }}>
          <Box style={{ color: "#757575", marginBottom: 8 }}>Hi Team,</Box>

          <TextField
            value={bodyBefore}
            onChange={(e) => onBodyBeforeChange(e.target.value)}
            fullWidth
            multiline
            InputProps={bodyFieldProps}
          />

          <Box style={{
            margin: "12px 0",
            padding: 12,
            backgroundColor: reasonHighlight ? "#fff3e0" : "#e8f5e9",
            border: `1px solid ${reasonHighlight ? "#ffcc80" : "#a5d6a7"}`,
            borderRadius: 4,
          }}>
            <TextField
              label={reasonLabel}
              value={reason}
              onChange={(e) => {
                if (e.target.value.length <= 500) onReasonChange(e.target.value);
              }}
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              placeholder={reasonPlaceholder}
              size="small"
              helperText={reasonHelperText}
              error={reasonError}
              style={{ backgroundColor: "#fff" }}
            />
          </Box>

          <TextField
            value={bodyAfter}
            onChange={(e) => onBodyAfterChange(e.target.value)}
            fullWidth
            multiline
            InputProps={bodyFieldProps}
          />

          <Box style={{ color: "#757575", marginTop: 12, fontStyle: "italic" }}>
            Thanks,<br />
            {"{{your name will be added here}}"}
          </Box>
        </Box>
      ) : (
        doneContent
      )}
    </DialogContent>
    <DialogActions style={{ padding: "12px 24px" }}>
      {!done ? (
        <>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSend}
            disabled={loading || sendDisabled}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? "Sending..." : "Send Email"}
          </Button>
        </>
      ) : (
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

export default ProviderEmailDialog;
